import { Routes } from '@angular/router';

import { HomeComponent } from '@src/app/home/home.component';
import { SummaryComponent } from './components/summary/summary.component';
import { UserdataComponent } from './components/userdata/userdata.component';
import { ExamComponent } from './components/exam/exam.component';
import { TrainingselectComponent } from './components/trainingselect/trainingselect.component';
import { TrainingFilesComponent } from './components/trainingfiles/trainingfiles.component';
import { VideoTrainingComponent } from './components/videotraining/videotraining.component';
import { ReportComponent } from './components/report/report.component';
import { LoginComponent } from './components/login/login.component';
import { YmComponent } from './components/ym/ym.component';
import { GatetypeComponent } from './components/gatetype/gatetype.component';
import { BookselectComponent } from './components/bookselect/bookselect.component';
// import { AuthGuard } from './services/authGuard.service';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/',
        pathMatch: 'full',
      },
      {
          path: '',
          component: HomeComponent,
      },
      {
        path: 'summary',
        component: SummaryComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'userdata',
        component: UserdataComponent
      },
      {
        path: 'exam',
        component: ExamComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'trainingselect',
        component: TrainingselectComponent
      },
      {
        path: 'trainingfiles',
        component: TrainingFilesComponent
      },
      {
        path: 'videotraining',
        component: VideoTrainingComponent
      },
      {
        path: 'report',
        component: ReportComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'ym/setdata',
        component: YmComponent
      },
      {
        path: 'gatetype',
        component: GatetypeComponent
      },
      {
        path: 'bookselect',
        component: BookselectComponent
      },
      {path: '**', redirectTo: ''}
];
